export const sleep = async (secundes = 1000) => {
    return new Promise((resolve) => setTimeout(() => resolve(), secundes));
};
